"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsFeedQueryAll = void 0;
var base_items_feed_query_class_1 = require("./base-items-feed-query.class");
var ItemsFeedQueryAll = /** @class */ (function (_super) {
    __extends(ItemsFeedQueryAll, _super);
    function ItemsFeedQueryAll(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
     * Gets the runnable Observable
     */
    ItemsFeedQueryAll.prototype.toObservable = function () {
        return _super.prototype.runItemsFeedQueryAll.call(this);
    };
    /**
     * Gets 'Url' representation of query
     */
    ItemsFeedQueryAll.prototype.getUrl = function () {
        return _super.prototype.getItemFeedQueryUrl.call(this);
    };
    return ItemsFeedQueryAll;
}(base_items_feed_query_class_1.BaseItemsFeedQuery));
exports.ItemsFeedQueryAll = ItemsFeedQueryAll;
//# sourceMappingURL=items-feed-query-all.class.js.map